import { PolicyLayout } from "../components/PolicyLayout";

export default function PrivacyChoices() {
  return (
    <PolicyLayout title="Your Privacy Choices" updated="November 2026" testId="privacy-choices-page">
      <p>Depending on where you live, you may have rights to opt out of certain uses of your personal information. Endure Beyond Media LLC does not sell your personal information, and we do not currently use advertising or cross-site tracking cookies — see our Privacy Policy for the technologies we do use.</p>

      <h2>Submitting a privacy choice</h2>
      <p>To make a privacy request — including access, correction, deletion, or any applicable opt-out — email <a href="mailto:edm@endurebeyondpod.com" className="underline hover:text-brandAccent">edm@endurebeyondpod.com</a>. We may ask to verify your identity before completing the request. We do not currently have an automated system that detects a browser-level opt-out signal such as Global Privacy Control; until that is in place, a direct request to the email above is the reliable way to exercise your choice.</p>

      <h2>Marketing email</h2>
      <p>If you subscribed to The Endure Beyond Dispatch, you can stop receiving it at any time by using the unsubscribe link in a given email once available, or by emailing us at the address above.</p>

      <h2>What an opt-out does not affect</h2>
      <p>Opting out of marketing communications does not disable the account, checkout, or security functions needed to operate your purchases and membership.</p>

      <h2>Learn more</h2>
      <p>See our full <a href="/privacy" className="underline hover:text-brandAccent">Privacy Policy</a> for how we collect and use information.</p>
    </PolicyLayout>
  );
}
